(function () {
  const initSearchTabs = (section) => {
    if (!section) return;
    const tabsPanel = section.querySelector(".search__tab-panel");
    if (!tabsPanel) return;
    const tabs = tabsPanel.querySelectorAll(".search__tab-panel-btn");
    const tabsContent = section.querySelectorAll(
      ".template-search__results-wrapper"
    );
    if (!tabs.length > 0 || !tabsContent.length > 0) return;
    tabs.forEach((tab) => {
      tab.addEventListener("click", (event) => {
        if (tab.classList.contains("active")) return;
        tabs.forEach((tab) => {
          if (tab !== event.target) {
            tab.classList.remove("active");
          } else {
            tab.classList.add("active");
          }
        });
        const tabId = tab.getAttribute("data-tab-id");
        const contentToShow = section.querySelector(
          `.template-search__results-wrapper[data-content="${tabId}"]`
        );
        tabsContent.forEach((content) => {
          if (content !== contentToShow) {
            content.classList.remove("active");
          } else {
            content.classList.add("active");
          }
        });
      });
    });
  };

  initSearchTabs(document.currentScript.parentElement);
  document.addEventListener("shopify:section:load", function (event) {
    initSearchTabs(event.target);
  });
})();
